__turbopack_context__.v({
  "asideCount": "collection-refinement-bar-module__yTIl1G__asideCount",
  "asideFooter": "collection-refinement-bar-module__yTIl1G__asideFooter",
  "asideHeader": "collection-refinement-bar-module__yTIl1G__asideHeader",
  "asidePanel": "collection-refinement-bar-module__yTIl1G__asidePanel",
  "asideRoot": "collection-refinement-bar-module__yTIl1G__asideRoot",
  "asideSections": "collection-refinement-bar-module__yTIl1G__asideSections",
  "asideShell": "collection-refinement-bar-module__yTIl1G__asideShell",
  "choiceList": "collection-refinement-bar-module__yTIl1G__choiceList",
  "choiceRow": "collection-refinement-bar-module__yTIl1G__choiceRow",
  "countBadge": "collection-refinement-bar-module__yTIl1G__countBadge",
  "desktopBar": "collection-refinement-bar-module__yTIl1G__desktopBar",
  "dropdown": "collection-refinement-bar-module__yTIl1G__dropdown",
  "dropdownBody": "collection-refinement-bar-module__yTIl1G__dropdownBody",
  "dropdownFooter": "collection-refinement-bar-module__yTIl1G__dropdownFooter",
  "dropdownHeader": "collection-refinement-bar-module__yTIl1G__dropdownHeader",
  "dropdownWrap": "collection-refinement-bar-module__yTIl1G__dropdownWrap",
  "filterGroup": "collection-refinement-bar-module__yTIl1G__filterGroup",
  "filterSurface": "collection-refinement-bar-module__yTIl1G__filterSurface",
  "iconButton": "collection-refinement-bar-module__yTIl1G__iconButton",
  "iconSpacer": "collection-refinement-bar-module__yTIl1G__iconSpacer",
  "label": "collection-refinement-bar-module__yTIl1G__label",
  "mobileBar": "collection-refinement-bar-module__yTIl1G__mobileBar",
  "mobileCount": "collection-refinement-bar-module__yTIl1G__mobileCount",
  "mobileTrigger": "collection-refinement-bar-module__yTIl1G__mobileTrigger",
  "panelActions": "collection-refinement-bar-module__yTIl1G__panelActions",
  "priceDash": "collection-refinement-bar-module__yTIl1G__priceDash",
  "priceField": "collection-refinement-bar-module__yTIl1G__priceField",
  "priceInputs": "collection-refinement-bar-module__yTIl1G__priceInputs",
  "primaryButton": "collection-refinement-bar-module__yTIl1G__primaryButton",
  "productCount": "collection-refinement-bar-module__yTIl1G__productCount",
  "secondaryButton": "collection-refinement-bar-module__yTIl1G__secondaryButton",
  "sortDropdown": "collection-refinement-bar-module__yTIl1G__sortDropdown",
  "sortGroup": "collection-refinement-bar-module__yTIl1G__sortGroup",
  "sortList": "collection-refinement-bar-module__yTIl1G__sortList",
  "sortOption": "collection-refinement-bar-module__yTIl1G__sortOption",
  "trigger": "collection-refinement-bar-module__yTIl1G__trigger",
});
